<script>
  export let id;
</script>

<div {id} {...$$props} data-spy>
  <slot />
</div>
